import '../../_rollupPluginBabelHelpers-a38db067.js';
import '../utils.js';
import '../core/core-utils.js';
import '../core/parser.js';
import '../core/style-function.js';
import { system } from '../core/system.js';

const config = {
  transition: {
    property: 'transition'
  },
  transitionProperty: {
    property: 'transitionProperty'
  },
  transitionDuration: {
    property: 'transitionDuration'
  },
  transitionTimingFunction: {
    property: 'transitionTimingFunction'
  },
  transitionDelay: {
    property: 'transitionDelay'
  }
};
const transition = system(config);

export { transition };
